/*! Copyright (c) Safe As Milk. All rights reserved. */
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.update();
    }
    static safeHref(uri) {
        if (typeof uri !== "string") return null;
        let url;
        try {
            url = new URL(uri, window.location.origin);
        } catch (e) {
            return null;
        }
        if (url.origin !== window.location.origin) return null;
        if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search(?:\/|$)/i.test(url.pathname)) return null;
        return `${url.pathname}${url.search}`;
    }
    update() {
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (recentSearchesStoredString) {
            const ul = this.querySelector("ul");
            let recentSearchesStored;
            try {
                recentSearchesStored = JSON.parse(recentSearchesStoredString);
            } catch (e) {
                return;
            }
            if (!Array.isArray(recentSearchesStored) || !ul) return;
            const items = recentSearchesStored.slice().reverse().reduce(((list, item) => {
                if (!item || typeof item !== "object" || typeof item.query !== "string") return list;
                const href = RecentSearches.safeHref(item.uri);
                if (!href) return list;
                const li = document.createElement("li");
                li.className = "search__nav-item";
                const a = document.createElement("a");
                a.className = "search__nav-link";
                a.href = href;
                a.textContent = String(item.query);
                li.appendChild(a);
                list.push(li);
                return list;
            }), []);
            if (items.length > 0) {
                this.parentElement.classList.add("has-recent-searches");
                ul.replaceChildren(...items);
                this.removeAttribute("hidden");
            }
        }
    }
}

customElements.define("recent-searches", RecentSearches);
//# sourceMappingURL=recent-searches.js.map
